import { Playground } from 'docz';
import * as React from 'react';
export default {
  Playground,
  React
};